import React, { useState } from 'react'
import classNames from 'classnames'
import i18n from '../../../../lib/i18n'
import ImageLabelBoard from '../../../QuestionsLearning/components/ImageLabelBoard/ImageLabelBoard'
import { slotCorrect } from '../../grading'
import Tile from './Tile'
import styles from './answers.module.scss'
import own from './AnswerImage.module.scss'

// type6: tap a label, then the place on the image; tap a filled place to take the label back
function AnswerImage({ question, draft, onChange, checked, order }) {
  const [selectedId, setSelectedId] = useState(null)
  const variants = question.answers?.variants || []
  const byId = Object.fromEntries(variants.map(_v => [_v._id, _v]))
  const placedIds = Object.values(draft)
  const bank = order.filter(id => !placedIds.includes(id))

  const onSlot = (slot) => {
    if (checked) return
    const next = { ...draft }
    if (selectedId) {
      // A label lives in one place only
      Object.keys(next).forEach(key => { if (next[key] === selectedId) delete next[key] })
      next[slot._id] = selectedId
      setSelectedId(null)
    } else if (next[slot._id]) {
      delete next[slot._id]
    } else {
      return
    }
    onChange(next)
  }

  return (
    <div className={styles.stack}>
      {!checked && (
        <div className={styles.pool}>
          {bank.length === 0 && <span className={styles.poolEmpty}>{i18n('qv_all_placed')}</span>}
          {bank.map(id => (
            <Tile
              key={id}
              compact
              aria-pressed={selectedId === id}
              state={selectedId === id ? 'selected' : undefined}
              onClick={() => setSelectedId(selectedId === id ? null : id)}
            >
              {byId[id]?.value}
            </Tile>
          ))}
        </div>
      )}

      <ImageLabelBoard
        image={question.answers?.image}
        variants={variants}
        renderSlot={(slot, index) => {
          const placed = byId[draft[slot._id]]
          const correct = checked && slotCorrect(question, draft, slot)
          return (
            <button
              type="button"
              disabled={checked}
              className={classNames(own.slot, {
                [own.filled]: Boolean(placed),
                [own.target]: Boolean(selectedId) && !checked,
                [own.correct]: correct,
                [own.wrong]: checked && !correct,
              })}
              aria-label={placed ? placed.value : `${i18n('qv_place')} ${index + 1}`}
              title={checked && !correct ? slot.value : undefined}
              onClick={() => onSlot(slot)}
            >
              <span className={own.text}>{placed ? placed.value : index + 1}</span>
            </button>
          )
        }}
      />

      {checked && variants.some(slot => !slotCorrect(question, draft, slot)) && (
        <div className={styles.correctHint}>
          {i18n('qv_correct_answer')}:{' '}
          <b>{variants.map((slot, i) => `${i + 1}. ${slot.value}`).join('  ')}</b>
        </div>
      )}
    </div>
  )
}

export default AnswerImage
